import { render, staticRenderFns } from "./solicitar-transferencia.vue?vue&type=template&id=3aeeff60&scoped=true&"
import script from "./solicitar-transferencia.vue?vue&type=script&lang=js&"
export * from "./solicitar-transferencia.vue?vue&type=script&lang=js&"
import style0 from "./solicitar-transferencia.vue?vue&type=style&index=0&id=3aeeff60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeeff60",
  null
  
)

export default component.exports